import axios from "lib/api";
import { useState } from "react";
import trackAnalytics from "trackAnalytics";

const useVerificationSubmit = (objections, onClose, entityId, endpointName) => {
    const [onSuccess, setOnSuccess] = useState(false);
    const [backEndErorr, setBackendErorr] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const unresolvedObjections = objections.filter((objection) => objection?.resolved === false);
    const unresolvedObjectionsDescriptions = unresolvedObjections.map(
        (objection) => objection?.description
    );
    const unresolvedObjectionsKeys = unresolvedObjections.map((objection) => objection?.item);
    const combinedObjectionsKeysAndDescriptions = unresolvedObjections.map((objection) => ({
        attribute: objection?.item,
        recjectionComment: objection?.description,
    }));

    const handleReviewSubmition = async () => {
        setIsLoading(true);
        const mappedData = {
            data: {
                type: `${endpointName}`,
                attributes: {
                    objectionsAttributes: [...objections],
                },
            },
        };
        await axios
            .post(`${endpointName}/${entityId}/review`, mappedData)
            .then(() => {
                setIsLoading(false);
                trackAnalytics(`Successful ${endpointName} verification submissions `, {
                    "Profile Id": entityId,
                    "Rejected Items": combinedObjectionsKeysAndDescriptions,
                    "Rejected Attributes": unresolvedObjectionsKeys,
                    "Rejection Comments": unresolvedObjectionsDescriptions,
                });
                onClose();
                setOnSuccess(true);
                window.location.reload(false);
            })
            .catch((err) => {
                setIsLoading(false);
                trackAnalytics(`Failed ${endpointName} verification submissions`);
                setBackendErorr(err?.errors);
            });
    };
    return { onSuccess, backEndErorr, isLoading, handleReviewSubmition };
};

export default useVerificationSubmit;
